/**
 * Formats a number of bytes into its highest multiple for readability, e.g. kilo, mega, giga, etc.
 * @param bytes {Number}
 * @param decimals {Number}
 * @returns {string}
 */
export default function formatBytes(bytes, decimals = 2) {
    if (typeof decimals !== 'number') {
        throw new Error('formatBytes: Decimal argument should be a number');
    }
    if (typeof bytes !== 'number') {
        return bytes;
    }
    if (bytes === 0) {
        return '0 Bytes';
    }
    const length = 1000;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const index = Math.floor(Math.log(bytes) / Math.log(length));
    return `${parseFloat((bytes / (length ** index)).toFixed(decimals))} ${sizes[index]}`;
}
